import gql from "graphql-tag";

export default gql`
  query inventoryItemQuery($id: Int!, $concreteShipmentId: Int!) {
    inventoryItem(id: $id) {
      itemShipmentQuantity(concreteShipmentId: $concreteShipmentId)
    }
  }
`;
